import { companyShortNameVar } from '@apolloClient/reactiveVars';
import { useCompanyShortNameLazyQuery } from '@hooks/authorize';
import { message } from 'antd';
import { createContext, ReactNode, useEffect } from 'react';
import { useAuth } from './AuthContext';

const CompanyContext = createContext(null);

export default function CompanyProvider(props: { children: ReactNode }) {
  const [fetchCompanyShortName] = useCompanyShortNameLazyQuery({
    onCompleted: data => {
      const companyShortName = data?.userProfile?.customer.salesOrg?.company.shortName;

      if (!companyShortName) {
        message.warn('Công ty không tồn tại!!!');
      } else {
        companyShortNameVar(companyShortName);
      }
    },
  });

  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (!isLoggedIn) return;

    fetchCompanyShortName();
  }, [isLoggedIn]);

  return <CompanyContext.Provider value={null}>{props.children}</CompanyContext.Provider>;
}
